import { toast } from "sonner";

// 统一的全局 Toast 提示封装 —— 适配 成功 / 错误 / 警告 / 信息 等不同状态。
// 用法: notify.success("已保存"), notify.error("密码错误") ...

const baseOptions = {
  duration: 3000,
  className: "font-mono text-xs",
};

function show(type, message, options = {}) {
  const opts = { ...baseOptions, ...options };
  const fn = toast[type] || toast;
  return fn(message, opts);
}

export const notify = {
  success: (message, options) => show("success", message, options),
  error: (message, options) => show("error", message, { duration: 4000, ...options }),
  warning: (message, options) => show("warning", message, options),
  info: (message, options) => show("info", message, options),
  loading: (message, options) => toast.loading(message, { ...baseOptions, ...options }),
  dismiss: (id) => toast.dismiss(id),
};

export default notify;
